// Produto em TELA INTEIRA no totem (o balcão continua com o popup). Mesma
// lógica do popup (usePopupProduto), só muda a apresentação: cabeçalho com
// nome/descrição à esquerda e foto à direita, corpo por etapa e rodapé
// Voltar / Próximo — estilo da referência do dono (10/09/2026).
import { ArrowLeft, ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";

import { fmt, getImageUrl } from "../../lib/helpers";
import DialogoPesoAlto from "../../popup-produto/DialogoPesoAlto";
import { usePopupProduto } from "../../popup-produto/usePopupProduto";
import EscolhaCombo from "./EscolhaCombo";
import EscolhaEtapa from "./EscolhaEtapa";
import ProdutoSimples from "./ProdutoSimples";
import ResumoProduto from "./ResumoProduto";

export default function TelaProduto({ ctx }) {
  const { telaCls, selectedProduct, addToCart, allProductsForPhotos, products, promotions, fecharProduto } = ctx;
  const h = usePopupProduto({
    product: selectedProduct, open: true, onClose: fecharProduto, onAddToCart: addToCart, modulo: "Totem",
    allProducts: allProductsForPhotos.length > 0 ? allProductsForPhotos : products, activePromotions: promotions,
  });
  const [verMais, setVerMais] = useState(false);
  const { isCombo, hasOrderSteps, comboStep, isOnSummaryStep, totalSteps, relevantSteps, selectedComboType, canAdvanceStep, handleNextStep, handleAdd, totalPrice, setComboStep, handleSelectComboType } = h;
  const naEscolhaCombo = !!selectedProduct && isCombo && comboStep === 0;
  // Recomendado (Combo) já vem pré-selecionado — pedido do dono (10/09/2026).
  // (hook antes do return condicional: regra dos hooks)
  useEffect(() => {
    if (naEscolhaCombo && !selectedComboType) handleSelectComboType("combo");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [naEscolhaCombo, selectedComboType, selectedProduct?.id]);
  if (!selectedProduct) return null;

  const noResumo = (isCombo || hasOrderSteps) && isOnSummaryStep;
  const nasEtapas = !naEscolhaCombo && !noResumo && comboStep > 0 && comboStep <= totalSteps && relevantSteps.length > 0;

  // Rodapé por etapa
  let primario = { rotulo: `Adicionar • R$ ${fmt(totalPrice)}`, acao: handleAdd, ok: true };
  let voltar = fecharProduto;
  if (naEscolhaCombo) primario = { rotulo: "Próximo", acao: handleNextStep, ok: !!selectedComboType };
  else if (nasEtapas) {
    primario = { rotulo: comboStep < totalSteps ? "Próximo" : "Revisar pedido", acao: handleNextStep, ok: canAdvanceStep() };
    voltar = () => (comboStep > 1 ? setComboStep(comboStep - 1) : isCombo ? setComboStep(0) : fecharProduto());
  } else if (noResumo) voltar = () => setComboStep(totalSteps > 0 ? totalSteps : 0);

  const foto = getImageUrl(
    naEscolhaCombo || !selectedComboType ? selectedProduct.photo_url
      : selectedComboType === "combo" ? (selectedProduct.combo_photo_url || selectedProduct.photo_url)
      : (selectedProduct.simple_photo_url || selectedProduct.photo_url),
  );
  const desc = selectedProduct.description || "";
  const descLonga = desc.length > 140;

  return (
    <div className={`${telaCls} bg-zinc-950 flex flex-col select-none`} data-e2e="tela-produto" data-etapa={naEscolhaCombo ? "combo" : nasEtapas ? "etapa" : noResumo ? "resumo" : "simples"}>
      {/* Cabeçalho: nome + descrição à esquerda, foto à direita */}
      <div className="px-8 pt-8 pb-5 flex gap-8 items-start border-b border-zinc-800/60">
        <div className="flex-1 min-w-0">
          <h1 className="text-4xl md:text-5xl font-black text-zinc-100 leading-tight" data-e2e="produto-nome">{selectedProduct.name}</h1>
          {desc && (
            <p className={`text-2xl md:text-[1.75rem] leading-snug text-zinc-300 mt-4 ${verMais ? "" : "line-clamp-4"}`} data-e2e="produto-descricao">
              {desc}
              {descLonga && !verMais && <button type="button" onClick={() => setVerMais(true)} className="ml-2 text-primary font-semibold underline underline-offset-2">Ver mais ›</button>}
            </p>
          )}
        </div>
        <div className="w-48 md:w-56 xl:w-72 shrink-0 aspect-square rounded-3xl overflow-hidden bg-zinc-900 border border-zinc-800" data-e2e="produto-foto">
          {foto ? <img src={foto} alt={selectedProduct.name} className="w-full h-full object-contain" /> : <div className="w-full h-full flex items-center justify-center text-6xl">🍽️</div>}
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-8 py-6">
        {naEscolhaCombo && <EscolhaCombo h={h} />}
        {nasEtapas && <EscolhaEtapa h={h} />}
        {noResumo && <ResumoProduto h={h} />}
        {!naEscolhaCombo && !nasEtapas && !noResumo && <ProdutoSimples h={h} />}
      </div>

      {/* Rodapé: Voltar e Próximo na cor do estabelecimento; Próximo bem largo */}
      <div className="border-t border-zinc-800 px-8 py-5 flex items-center justify-between gap-6 bg-zinc-950">
        {/* Voltar = só a palavra sublinhada (sem card), na cor do tema — pedido do dono */}
        <button type="button" onClick={voltar} data-e2e="produto-voltar" className="h-16 px-2 text-primary text-2xl font-bold underline underline-offset-8 decoration-2 flex items-center gap-2 hover:opacity-80 active:scale-95 transition-transform">
          <ArrowLeft className="w-7 h-7" /> Voltar
        </button>
        <button type="button" onClick={primario.acao} disabled={!primario.ok} data-e2e="produto-primario" className="flex-1 max-w-3xl h-20 px-12 rounded-full bg-primary text-primary-foreground text-2xl font-black flex items-center justify-center gap-3 disabled:opacity-40 active:scale-95 transition-transform shadow-xl shadow-primary/30">
          {primario.rotulo} {primario.rotulo === "Próximo" && <ChevronRight className="w-7 h-7" />}
        </button>
      </div>
      {/* Mais de 30 kg/L pede confirmação antes de adicionar (30/09/2026). */}
      <DialogoPesoAlto {...h.dialogoPeso} />
    </div>
  );
}
